module.exports = __webpack_public_path__ + "img/def537b.jpg";